var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEventsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Opportunities"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-442.05,450 -506.52,450 -506.52,405.06 -854.96,405.06 -854.96,645.66 -93.61,645.66  -93.61,405.06 -442.05,405.06  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-306.16,217.19v-45.17h-0.01v-52.73h-361.41v52.73v11.74v33.43h-187.38v148.76h348.44V321h64.47v44.94 h348.44V217.19H-306.16z M-603.1,217.19v-33.43h232.47v33.43H-603.1z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Jobs_00000076601316891415926100000013887333141794878877_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -234.58,
    y: 1206.32,
    className: "st0",
    width: 98.15,
    height: 30.48
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -812.14,
    y: 1206.32,
    className: "st0",
    width: 98.15,
    height: 30.48
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -511.16,
    y: 926.4,
    transform: "matrix(0.0368 -0.9993 0.9993 0.0368 -1386.0979 445.2545)",
    className: "st0",
    width: 98.15,
    height: 30.48
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -306.06,
    y: 1014.92,
    transform: "matrix(0.7326 -0.6806 0.6806 0.7326 -769.876 100.526)",
    className: "st0",
    width: 98.15,
    height: 30.48
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -740.65,
    y: 1406.35,
    transform: "matrix(0.7326 -0.6806 0.6806 0.7326 -1152.5046 -90.6104)",
    className: "st0",
    width: 98.15,
    height: 30.48
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -689.56,
    y: 963.82,
    transform: "matrix(0.7326 -0.6806 0.6806 0.7326 -869.7172 -188.1416)",
    className: "st0",
    width: 30.48,
    height: 98.15
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -289.48,
    y: 1389.78,
    transform: "matrix(0.7326 -0.6806 0.6806 0.7326 -1052.6635 198.0572)",
    className: "st0",
    width: 30.48,
    height: 98.15
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-597.63,1387.7h246.32c48.84-37.23,80.61-95.71,80.61-161.87c0-112.57-91.26-203.83-203.83-203.83 s-203.83,91.26-203.83,203.83C-678.36,1292.02-646.52,1350.47-597.63,1387.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-586.18,1418.17 -586.18,1541.23 -530.82,1541.23 -530.82,1568.91 -415.06,1568.91  -415.06,1541.23 -359.7,1541.23 -359.7,1418.17  "
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Companies"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-1156.49,1527.68v-526.75h-155.64v-98.15h-30.48v98.15h-155.64v526.75h-68.15v30.48h482.89v-30.48H-1156.49 z M-1261.56,1056.15h64.47v120.36h-64.47V1056.15z M-1261.56,1231.73h64.47v120.36h-64.47V1231.73z M-1357.19,1056.15h64.47 v120.36h-64.47V1056.15z M-1357.19,1231.73h64.47v120.36h-64.47V1231.73z M-1457.65,1056.15h64.47v120.36h-64.47V1056.15z  M-1457.65,1231.73h64.47v120.36h-64.47V1231.73z M-1357.19,1527.68v-120.36h64.47v120.36H-1357.19z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Community"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-2095.3,1456.77 -2177.63,1539.09 -2259.96,1456.77 -2405.83,1456.77 -2405.83,1615.16  -1934.73,1615.16 -1934.73,1456.77  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-2147.83,1194.71 -2147.83,1299.86 -2212.3,1299.86 -2212.3,1194.71 -2335.52,1194.71  -2296.36,1377.45 -2070.14,1377.45 -2030.97,1194.71  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-2039.59,1008.32 -2315.5,1008.32 -2324.17,1064.2 -2368.99,1057.25 -2344.65,1170.82  -2025.89,1170.82 -1934.73,1008.32  "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Blog"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -1454.18,
    y: 189.19,
    transform: "matrix(0.5168 -0.8561 0.8561 0.5168 -817.1639 -944.2964)",
    className: "st0",
    width: 418.12,
    height: 125.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-1418.58,539.1 -1312.45,483.56 -1418.87,419.32  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-1100.18,71.8 -1153.39,39.68 -1190.29,40.66 -1191.5,102.81 -1138.29,134.93 -1083.86,104.91  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -1566.4,
    y: 613.52,
    className: "st0",
    width: 482.89,
    height: 30.48
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -1566.4,
    y: 545.79,
    className: "st0",
    width: 147.53,
    height: 30.48
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Forum"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-2320.81,453 -2320.81,337.38 -2380.24,337.38 -2380.24,96.63 -2442.64,96.63 -2442.64,512.78  -2158.7,512.78 -2019.84,650.34 -2019.84,512.78 -1958.88,512.78 -1958.88,337.38 -2204.11,337.38  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-1897.93,33.33 -2380.24,33.33 -2380.24,96.63 -1958.88,96.63 -1958.88,337.38 -1897.93,337.38  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "400,267.28 441.18,350.72 533.26,364.1 466.63,429.05 482.36,520.76 400,477.46 317.64,520.76  333.37,429.05 266.74,364.1 358.82,350.72  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "87.29,208.31 712.54,208.31 712.71,291.56 780.67,291.56 780.67,138.67 19.33,138.67 19.33,291.56  87.46,291.56  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "87.37,581.32 87.37,495.78 19.33,495.78 19.33,649.37 780.67,649.37 780.67,495.78 712.63,495.78  712.63,581.32  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 87.72,
    y: 291.56,
    className: "st0",
    width: 68.05,
    height: 204.22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 644.52,
    y: 291.56,
    className: "st0",
    width: 68.05,
    height: 204.22
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Forum_copy"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsIcon);
export default __webpack_public_path__ + "static/media/events-icon.b0d44f7c.svg";
export { ForwardRef as ReactComponent };